import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icf-bar-percent',
  standalone: true,
  imports: [],
  templateUrl: './icf-bar-percent.component.html',
  styleUrl: './icf-bar-percent.component.scss',
})
export class IcfBarPercentComponent {
  @Input() value: number = 100;
  @Input() erfuellung: boolean = false;

  damageLevels = [
    { icf: 4, min: 96, max: 100, color: '#F4856D' }, // Schädigung voll ausgeprägt
    { icf: 3, min: 50, max: 95, color: '#EEB27B' }, // Schädigung erheblich ausgeprägt
    { icf: 2, min: 25, max: 49, color: '#E8E596' }, // Schädigung mäßig ausgeprägt
    { icf: 1, min: 5, max: 24, color: '#F4F7D0' }, // Schädigung leicht ausgeprägt
    { icf: 0, min: 0, max: 4, color: 'lightgray' }, // Schädigung nicht vorhanden
  ];
  erfuellungLevels = [
    { icf: 0, min: 96, max: 100, color: '#9cd486' }, // Erfüllung voll erreicht
    { icf: 1, min: 76, max: 95, color: '#c7ed8b' }, //  Erfüllung erheblich ausgeprägt
    { icf: 2, min: 51, max: 75, color: '#E8E596' }, //  Erfüllung mäßig ausgeprägt
    { icf: 3, min: 5, max: 50, color: '#EEB27B' }, //  Erfüllung leicht ausgeprägt
    { icf: 4, min: 0, max: 4, color: '#F4856D' }, //  Erfüllung nicht vorhanden
  ];

  /*

  0: Schädigung nicht vorhanden (0 - 4 %)

1: Schädigung leicht ausgeprägt (5 - 24 %)

2: Schädigung mäßig ausgeprägt (25 - 49 %)

3: Schädigung erheblich ausgeprägt (50 - 95 %)

4: Schädigung voll ausgeprägt (96 - 100 %)

    { min: 96, max: 100, color: 'rgba(251,221,221,1)' }, // Schädigung voll ausgeprägt
    { min: 50, max: 95, color: 'rgba(255,228,200,1)' }, // Schädigung erheblich ausgeprägt
    { min: 25, max: 49, color: 'rgba(252,244,219,1)' }, // Schädigung mäßig ausgeprägt
    { min: 5, max: 24, color: 'rgba(252,252,239,1)' }, // Schädigung leicht ausgeprägt
    { min: 0, max: 4, color: 'white' }, // Schädigung nicht vorhanden


  drawChartBackground(gradientBack: any) {
    gradientBack.addColorStop(0, 'rgba(255,255,255,1)');
    gradientBack.addColorStop(0.2, 'rgba(255,255,255,1)');

    gradientBack.addColorStop(0.2, 'rgba(252,252,239,1)');
    gradientBack.addColorStop(0.4, 'rgba(252,252,239,1)');

    gradientBack.addColorStop(0.4, 'rgba(252,244,219,1)');
    gradientBack.addColorStop(0.6, 'rgba(252,244,219,1)');

    gradientBack.addColorStop(0.6, 'rgba(255,228,200,1)');
    gradientBack.addColorStop(0.8, 'rgba(255,228,200,1)');

    gradientBack.addColorStop(0.8, 'rgba(251,221,221,1)');
    gradientBack.addColorStop(1, 'rgba(251,221,221,1)');
  */

  getColor(): string {
    if (this.erfuellung) {
      return this.erfuellungLevels[0].color;
    }
    const levels = this.erfuellung ? this.erfuellungLevels : this.damageLevels;
    for (const level of levels) {
      if (this.value >= level.min && this.value <= level.max) {
        return level.color;
      }
    }
    return 'white'; // Standardfarbe, falls keine Bedingung zutrifft
  }
}
